import { render } from "./addOfferOrder.vue?vue&type=template&id=1bd7e2f4&scoped=true"
import script from "./addOfferOrder.vue?vue&type=script&lang=js"
export * from "./addOfferOrder.vue?vue&type=script&lang=js"

import "./addOfferOrder.vue?vue&type=style&index=0&id=1bd7e2f4&scoped=true&lang=less"

import exportComponent from "D:\\wkb\\dev\\study\\盘雷\\lida-web\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1bd7e2f4"]])

export default __exports__